<template>
  <div>
    <button ref="button" @click="copyToClipBoard"
            class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase">
      <slot></slot>
    </button>
    <div class="hidden-wrap">
      <input ref="text" type="text" :value="textToCopy" readonly contentEditable="true"
             class="hidden-input"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyButton',
  props: ['textToCopy'],
  methods: {
    copyToClipBoard () {
      const copyText = this.$refs.text
      copyText.select()
      document.execCommand('copy')
      this.$refs.button.focus()
    }
  }
}
</script>

<style scoped>
  .hidden-wrap {
    position: relative;
    overflow: hidden;
  }
  .hidden-input {
    position: absolute;
    width: 100px;
    right: -50px;
    top: 50px;
  }
</style>
